/**
 * KitCountrySelect — replaces src/components/form/dropdowns/CountrySelect.tsx
 * on the kit's Select. Same virtualized country list + flag rendering.
 */
import { countries } from "countries-list";
import ReactCountryFlag from "react-country-flag";
import type { KitSelectProps } from "./Select";
import { KitSelect, KitSelectItem } from "./Select";

const countryItems = Object.entries(countries)
  .sort()
  .map(([code, country]) => ({ id: code, name: country.name }));

export function KitCountrySelect({
  ...props
}: Omit<KitSelectProps<(typeof countryItems)[number]>, "children">) {
  return (
    <KitSelect
      placeholder="Select a country"
      id="country"
      aria-label="Select country"
      layoutOptions={{ rowHeight: 41, gap: 0, padding: 8 }}
      items={countryItems}
      {...props}
    >
      {(item: { id: string; name: string }) => (
        <KitSelectItem id={item.id} className="flex items-center gap-3" textValue={item.name}>
          <ReactCountryFlag countryCode={item.id} svg style={{ width: "28px", height: "20px" }} className="rounded-none border border-co-line2" />
          {item.name}
        </KitSelectItem>
      )}
    </KitSelect>
  );
}
